import { getProvider, getWeb3, waitForConfirmation } from ".";
import config from "../../config/config";

import MafiaHelperCreditAbi from "../../abis/MafiaHelperCredit.json";
import { ethers } from "ethers";
import { SwapToken } from "../../types/Contract/SwapToken";

export const getMafiaHelperCreditContract = (provider = false) => {
  const web3 = provider ? getProvider() : getWeb3();
  const contractAddress = config.helperCreditAddress;
  const MafiaHelperCreditContract = new web3.eth.Contract(
    MafiaHelperCreditAbi,
    contractAddress
  );

  return MafiaHelperCreditContract;
};

export const balanceOfHelperCredit = async (
  address: string,
  signMsg: string,
  signature: string
) => {
  const MafiaHelperCreditContract = getMafiaHelperCreditContract();
  const balance: number = await MafiaHelperCreditContract.methods
    .balanceOf(address, JSON.stringify(signMsg), signature)
    .call();
  const decimal: string = await MafiaHelperCreditContract.methods
    .decimals()
    .call();
  return ethers.utils.formatUnits(balance, decimal);
};

export const getHelperCreditAllowance = async (from: string, to: string) => {
  const MafiaHelperCreditContract = getMafiaHelperCreditContract();
  const decimals = Number(
    await MafiaHelperCreditContract.methods.decimals().call()
  );
  const data = await MafiaHelperCreditContract.methods
    .allowances(from, to)
    .call();
  return Number(
    ethers.utils.formatUnits(ethers.BigNumber.from(data), decimals.toString())
  );
};

export const approveHelperCredit = async (
  amount: number,
  to: string,
  account: string
) => {
  const MafiaHelperCreditContract = getMafiaHelperCreditContract(true);
  const decimals = Number(
    await MafiaHelperCreditContract.methods.decimals().call()
  );

  const data = await MafiaHelperCreditContract.methods
    .approve(
      to,
      ethers.utils
        .parseUnits(Number(amount).toFixed(decimals), decimals)
        .toString()
    )
    .send({ from: account });

  return data;
};

export const getHelperCreditSwapTokens = async () => {
  const MafiaHelperCreditContract = getMafiaHelperCreditContract();
  const data: any = await MafiaHelperCreditContract.methods
    .getSwapTokens()
    .call();

  let swapTokenInfo: SwapToken[] = data[0].map(
    (tokenInfo: any, index: number) => ({
      name: tokenInfo.name,
      tokenAddress: tokenInfo.tokenAddress,
      isStable: tokenInfo.isStable,
      isEnabled: tokenInfo.isEnabled,
      price: Number(tokenInfo.price),
      decimal: Number(tokenInfo.decimal),
      tokenId: index,
    })
  );

  swapTokenInfo.forEach(
    (tokenInfo: SwapToken, index: number) =>
      (tokenInfo.price = Number(ethers.utils.formatEther(data[1][index])))
  );

  return swapTokenInfo;
};

export const getHelperPrice = async () => {
  const MafiaHelperCreditContract = getMafiaHelperCreditContract();
  const data: any = await MafiaHelperCreditContract.methods.price().call();

  return Number(ethers.utils.formatEther(data));
};

export const buyCredit = async (
  account: string,
  tokenInfo: SwapToken,
  amount: number
) => {
  const MafiaHelperCreditContract = getMafiaHelperCreditContract(true);

  const amountWei = ethers.utils
    .parseUnits(amount.toFixed(tokenInfo.decimal), tokenInfo.decimal.toString())
    .toString();
  let data;
  if (tokenInfo.tokenId === 0) {
    const sendAmount = ethers.utils
      .parseUnits(
        (amount * 1.001).toFixed(tokenInfo.decimal),
        tokenInfo.decimal.toString()
      )
      .toString();

    data = await MafiaHelperCreditContract.methods
      .buyCredit(tokenInfo.tokenId, amountWei)
      .send({ value: sendAmount, from: account });
  } else {
    data = await MafiaHelperCreditContract.methods
      .buyCredit(tokenInfo.tokenId, amountWei)
      .send({ from: account });
  }

  await waitForConfirmation(data.transactionHash);
  return data.transactionHash;
};
